import { faStar as star } from '@fortawesome/free-regular-svg-icons';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { userInstrumentsSlice } from '!core/redux';
import { TrlFlag, TrlPriceType } from '»components/atoms';
import { useCurrentPage } from '»utils/customHooks';

import {
  FavoriteIcon,
  HeaderDiv,
  Separator,
  StockInfo,
  StockName,
  StockNameContainer,
  UpperContent,
} from './TrlMainDetails.styles';

export const TrlMainDetails = ({
  instrument,
  symbol,
  exchange,
  securityType,
  country,
  exchangeDescr,
  currency,
  descr,
  priceRepresentation,
  favourite,
  isCardMobileList,
  isCardMobileDetails,
}) => {
  const dispatch = useDispatch();

  const { isMarketStockExchangePage, isMarketStockExchangeDetailsPage } =
    useCurrentPage();

  const isFavourite = favourite === 'Y';

  const setFavInstrument = () => {
    dispatch(
      userInstrumentsSlice.actions.setFavInstrumentRequest({
        option: isFavourite ? 'D' : 'I',
        instrument,
        symbol,
        exchange,
        securityType,
      }),
    );
  };

  const handleFavorite = (e) => {
    e.stopPropagation();
    setFavInstrument();
  };

  const getInfo = () => {
    return (
      <StockInfo isCardMobileList={isCardMobileList}>
        {symbol}
        <Separator />
        <Box sx={{ display: 'flex' }}>
          <TrlFlag flag={country} />
          {exchangeDescr}
        </Box>
        <Separator />
        {currency}
        {!isCardMobileDetails && isMarketStockExchangePage && (
          <>
            <Separator />
            <TrlPriceType value={priceRepresentation} />
          </>
        )}
      </StockInfo>
    );
  };

  const getUpperContent = () => {
    return (
      <>
        {(isMarketStockExchangePage || isMarketStockExchangeDetailsPage) && (
          <FavoriteIcon
            disabled={false}
            icon={isFavourite ? solidStar : star}
            onClick={handleFavorite}
            isCardMobileList={isCardMobileList}
            isCardMobileDetails={isCardMobileDetails}
          />
        )}
        <StockNameContainer
          isCardMobileList={isCardMobileList}
          isCardMobileDetails={isCardMobileDetails}
        >
          <StockName title={descr}>{descr}</StockName>
        </StockNameContainer>
      </>
    );
  };

  return (
    <HeaderDiv
      isCardMobileList={isCardMobileList}
      isCardMobileDetails={isCardMobileDetails}
    >
      {isCardMobileList || isCardMobileDetails ? (
        <UpperContent>{getUpperContent()}</UpperContent>
      ) : (
        getUpperContent()
      )}
      {getInfo()}
    </HeaderDiv>
  );
};

TrlMainDetails.propTypes = {
  instrument: PropTypes.number,
  symbol: PropTypes.string,
  exchange: PropTypes.string,
  securityType: PropTypes.string,
  country: PropTypes.string,
  exchangeDescr: PropTypes.string,
  currency: PropTypes.string,
  descr: PropTypes.string,
  priceRepresentation: PropTypes.string,
  favourite: PropTypes.string,
  isCardMobileList: PropTypes.bool,
  isCardMobileDetails: PropTypes.bool,
};
